import React from 'react';

// For CSS
import './iconSelect.css';


const IconSelect = (props) => {
    
    return (
        <div className={`iconSelectInput ${props.className}`}>
            <select onChange={props.onChange} value={props.value} >
                {props.items && props.items.length > 0 && props.items.map((item) => <option value={item.value} key={item.value}>{item.label}</option>)}
            </select>
            <label>{props.labelText}</label>
            <div className="iconBox invertGray">
                <img alt="selecticon" {...props} />
            </div>
        </div>
    )
}
export default IconSelect;



